import React from 'react';
import { Box } from '@mui/material';
import { Footer } from '@motivo/guanyin/src/components';
import { useLocation } from 'react-router';
import Snackbar from '../Snackbar';
import Header from '../Header';
import AppWideBanner from './AppWideBanner';
import OnboardingDemoBanner from './OnboardingDemoBanner';
import useViewer from ':src/hooks/useViewer';
import { isDemoOrganization } from ':src/domains/basic/demoOrganizations';
import DemoControlPanel from ':src/domains/basic/components/DemoControlPanel';

type LayoutProps = {
  children: React.ReactNode;
  hideHeader?: boolean;
  hideHeaderLinks?: boolean;
  hideFooter?: boolean;
};

export default function Layout({ children, hideHeader, hideHeaderLinks, hideFooter }: LayoutProps) {
  const location = useLocation();
  const isChatPage = location.pathname.startsWith('/chats');
  const { viewer } = useViewer();
  const isMotivoBasicDemo = isDemoOrganization(viewer.organizationId);

  return (
    <>
      <Box height="100vh" display="flex" flexDirection="column">
        {!hideHeader && <Header hideLinks={hideHeaderLinks} />}
        <AppWideBanner />
        <OnboardingDemoBanner />
        <Box flex={1} overflow={isChatPage ? 'hidden' : 'initial'}>
          {children}
        </Box>
        {!isChatPage && !hideFooter && <Footer />}
      </Box>
      {isMotivoBasicDemo && <DemoControlPanel />}
      <Snackbar />
    </>
  );
}
